import { render, staticRenderFns } from "./StockGroupSalesPurchaseBarChart.vue?vue&type=template&id=1d1a4790"
import script from "./StockGroupSalesPurchaseBarChart.vue?vue&type=script&lang=ts"
export * from "./StockGroupSalesPurchaseBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports